import { Navigate, useParams } from "react-router-dom";

export default function RedirectLegacyPagesRoute() {
  const { siteId } = useParams();

  return <Navigate to={siteId ? `/app/editor/${siteId}` : "/app"} replace />;
}
